module.exports = __webpack_public_path__ + "static/media/bg-take-prize-thadingyut-2025-theme-pc.29c5e8c5.png";